import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { StandardMenuService } from '../service/standard-menu.service';

export const menuGuard: CanActivateFn = (route, state) => {
  const menuService = inject(StandardMenuService);
  const router = inject(Router);

  if (menuService.isLoaded) {
    if (state.url === '/changelogs') {
      return true;
    }

    if (state.url.includes('preset/')) {
      return true;
    }

    if (state.url.includes('cartography/')) {
      return true;
    }

    if (
      !environment.production &&
      (state.url === '/lab/bs' || state.url === '/lab/asc')
    ) {
      return true;
    }

    if (menuService.isAllowed(state.url) || state.url.includes('error')) {
      return true;
    }

    router.navigate(['/activity']).then();
    // router.navigateByUrl('error/403').then();
    return false;
  }

  router.navigateByUrl('not-found/601').then();
  return false;
};
